export default "__VITE_ASSET__851KKJbF__"